'use client'
import React, { Children, useRef } from 'react';
import clsx from 'clsx';

import { TabsProvider } from "@/stories/components/Tabs/TabsContext";
import { useTabs } from "@/stories/components/Tabs/Tabs";
import { useTab } from "@/stories/components/Tabs/Tab";
import { useTabPanel } from '@/stories/components/Tabs/TabPanel';
import { Button } from "@/stories/atoms/Button/Button";

import styles from './annonces-switch.module.css'


export const TabButton = ({ label, index}: { label: string, index: number}) => {
  const ref = useRef<HTMLButtonElement | null>(null)
  const {isActive, setCurrentIndex, tabProps} = useTab(ref, index, 'annonce-tab', 'annonce-panel')

  return (
    <Button
      ref={ref}
      {...(!isActive && {tabIndex: -1, variant: 'secondary'})}
      onClick={() => setCurrentIndex(index)}
      {...tabProps}
      className={clsx(isActive && styles.active )}>
      {label}
    </Button>
  )
};

const TabTabs = ({children}: React.PropsWithChildren) => {
  const {handleKeyDown} = useTabs(Children.count(children))

  return (
    <div role='tablist' onKeyDown={handleKeyDown} className={styles.tabs}>{children}</div>
  )
}

const Panel = ({index, children}: {index: number} & React.PropsWithChildren) => {
  const {isActive, panelProps} = useTabPanel(index, 'annonce-panel', 'annonce-tab')

  return (
    <div hidden={!isActive} className={styles.panel} {...panelProps}>{children}</div>
  )
}

/** onglets et panneaux ; le contenu de chaque panneau est rendu côté serveur (un enfant par libellé) */
export const AnnoncesTabs = ({labels, children}: {labels: string[]} & React.PropsWithChildren) => (
  <TabsProvider>
    {labels.length > 1 && <TabTabs>
      {labels.map((label, i) => (
        <TabButton key={i} index={i} label={label}/>
      ))}
    </TabTabs>
    }
    {Children.toArray(children).map((child, i) => (
      <Panel key={i} index={i}>{child}</Panel>
    ))}
  </TabsProvider>
)
